<template>
  <SearchContainer @on-search-toggle="onSearchToggle" />
</template>

<script>
import SearchContainer from '~legacy-vue/vueComponents/SearchModal/SearchModalContainer.vue'

const SearchModal = {
  delimiters: ['{$', '$}'],
  components: {
    SearchContainer,
  },

  emits: ['on-search-toggle'],

  methods: {

    /**
     * A method that is called when the search modal is toggled.
     *
     * @param {Boolean} isSearchOpened - Emitted value, which indicates the
     * current state of search overlay
     *
     * @emits `on-search-toggle`
     */
    onSearchToggle(isSearchOpened) {
      this.$emit('on-search-toggle', isSearchOpened)
    },
  },
}

export default SearchModal
</script>
